import { render, staticRenderFns } from "./InfoCdaPremium.vue?vue&type=template&id=81445bbc"
import script from "./InfoCdaPremium.vue?vue&type=script&lang=js"
export * from "./InfoCdaPremium.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports